import { InfoDialog } from './info-dialog';
// Discord's own mark in Discord's own colour, which no theme changes
import discordLogo from '@/assets/discord-logo.svg';

const CHANNELS = [
  { name: 'announcements', about: 'Latest Lureo updates and news' },
  { name: 'inspiration-and-ideas', about: 'Share and discover creative concepts' },
  { name: 'show-and-tell', about: 'Showcase your projects and experiences' },
  { name: 'bugs-and-issues', about: 'Report issues and track fixes' },
  { name: 'help-and-support', about: 'Get help from the community and team' },
  { name: 'creator-competition', about: 'Everything about the competition' },
];

interface DiscordDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function DiscordDialog({ open, onOpenChange }: DiscordDialogProps) {
  const handleJoinDiscord = () => {
    // TODO: Replace with actual Discord invite link when available
    window.open('https://discord.com/invite/ZrthQXgp5a', '_blank');
    onOpenChange(false);
  };

  return (
    <InfoDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Join the Lureo Creator Community"
      // description="Connect with other creators, get support, and stay up to date with Lureo"
      icon={<img src={discordLogo} alt="" aria-hidden className="h-12 w-12" />}
      actionButton={{
        label: 'Join Discord',
        onClick: handleJoinDiscord,
        variant: 'secondary'
      }}
      secondaryButton={{
        label: 'Close',
        onClick: () => onOpenChange(false),
        variant: 'outline-3'
      }}
    >
      <div className="space-y-3 text-lureo-14 text-lureo-ink-subtle leading-5">
        <p className="text-center font-semibold">
          The best place to stay connected with Lureo and the creator community!
        </p>
        <div className="space-y-2 rounded-lureo-radius-lg bg-lureo-surface/60 p-4 shadow-lureo-shadow-bar">
          {CHANNELS.map(({ name, about }) => (
            <div key={name} className="flex items-start">
              {/* Discord's channel mark, in the violet nearest Discord's blue */}
              <span className="mr-2 font-bold text-lureo-violet">#</span>
              <div>
                <p className="font-semibold">{name}</p>
                <p className="text-lureo-12 leading-4">{about}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </InfoDialog>
  );
}
